export default __webpack_public_path__ + "tailwind.61f3c647.png";